export function homeForRole(role: string): string {
  return role === 'admin' ? '/admin/families' : '/'
}

function belongsToRole(role: string, pathname: string): boolean {
  if (role === 'admin') {
    return pathname === '/admin' || pathname.startsWith('/admin/')
  }
  return pathname === '/' || pathname.startsWith('/devices/')
}

export function destinationFor(role: string, from: string | undefined): string {
  if (from !== undefined && belongsToRole(role, from)) {
    return from
  }
  return homeForRole(role)
}
